<!-- =========================
     FULLSCREEN BACKGROUND
========================= -->
<div class="min-vh-100 d-flex align-items-center position-relative">
  <div class="container">
    <div class="row justify-content-center">

      <!-- =========================
           PASSWORD RESET COMPLETE
      =========================== -->
      <div class="glass-card p-4 p-md-5 rounded-4 shadow-sm col-12 col-sm-8 col-md-6 col-lg-5 col-xl-5 mx-auto">

        <!-- Logo -->
        <div class="text-center mb-3">
          <router-link
            to="/"
            class="auth-logo mb-2 text-decoration-none d-inline-block"
            aria-label="Bolide Home"
          ></router-link>

        </div>
        <!-- Heading -->
        <h3 class=" mb-1 text-center text-white">
          Password Reset Complete
        </h3>

        <p class="text-center text-white-50 mb-4 text-sm">
          Your password has been successfully reset.  
          You can now log in using your new credentials.
        </p>

        <!-- SUCCESS MESSAGE -->
        <div 
          v-if="success_message" 
          class="alert alert-success alert-dismissible fade show rounded-3"
          role="alert"
        >
          {{ success_message }}
          <button 
            type="button" 
            class="btn-close"
            @click="success_message = ''"
          ></button>
        </div>

        <!-- Back To Login -->
        <div class="text-center">
          <router-link 
            to="/login" 
            class="btn btn-primary w-100 rounded-3 fw-light text-xs"
          >
            Go to Login
          </router-link>
        </div>

      </div>

    </div>
  </div>
</div>
